module.exports = __webpack_public_path__ + "static/media/style1.e97066ea.svg";